import React, { useState, useEffect } from "react";
import Modal from "react-modal"; // For modal functionality
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { scanBarcode } from "../services/clinic/medicine_invoice";

// Make sure to bind modal to the app element
Modal.setAppElement("#root");

const MedicineScanner = ({ isOpen, onClose, handleScanResult }) => {
    const [barcode, setBarcode] = useState("");
    const [error, setError] = useState(null);

    // Reset state when modal opens
    useEffect(() => {
        if (isOpen) {
            setBarcode(""); // Clear previous barcode
            setError(""); // Clear previous error
        }
    }, [isOpen]);

    // Fetch medicine details from the server
    const fetchMedicineDetails = async (barcodeId) => {
        try {
            const response = await scanBarcode(barcodeId);
            if (response.status === 200) {
                handleScanResult(response.data); // Send result back to parent
                onClose(); // Close modal on success
                setError(""); // Reset error
            } else {
                setError(response.data.error || "No medicine found for the scanned barcode.");
            }
        } catch (err) {
            setError("Failed to fetch medicine details. Please try again.");
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Medicine Scanner"
            style={{
                content: {
                    top: "50%",
                    left: "50%",
                    right: "auto",
                    bottom: "auto",
                    marginRight: "-50%",
                    transform: "translate(-50%, -50%)",
                    width: "30%",
                    maxWidth: "95%", // Responsive for mobile
                    zIndex: 1050,
                    padding: "20px",
                },
                overlay: {
                    zIndex: 1040,
                    backgroundColor: "rgba(0, 0, 0, 0.75)",
                },
            }}
        >
            <h2 style={{ marginBottom: "20px" }}>Scan Medicine Barcode</h2>
            {/* Barcode Scanner Component */}
            <BarcodeScannerComponent
                width={300}
                height={300}
                onUpdate={(err, result) => {
                    // Reset error at each scan attempt
                    setError(null);
                    if (result) {
                        const scannedCode = result.text;
                        if (scannedCode !== barcode) {
                            setBarcode(scannedCode); // Update barcode
                            fetchMedicineDetails(scannedCode); // Fetch medicine details
                        }
                    } else if (err) {
                        setError("Barcode scanning failed. Please try again.");
                    }
                }}
            />

            {/* Error Handling */}
            {error && (
                <div style={{ color: "red", marginTop: "15px" }}>
                    <p>{error}</p>
                </div>
            )}

            {/* Display Scanned Barcode */}
            {barcode && (
                <div style={{ marginTop: "10px" }}>
                    <p>
                        <strong>Scanned Barcode:</strong> {barcode}
                    </p>
                </div>
            )}

            {/* Close Modal Button */}
            <button
                onClick={onClose}
                style={{
                    marginTop: "20px",
                    padding: "10px 20px",
                    backgroundColor: "#f44336",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                }}
            >
                Close
            </button>
        </Modal>
    );
};

export default MedicineScanner;
